import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import Icon from './AppIcon';
import Button from './ui/Button';
import { APP_NAME } from '../constants';

const PublicMarketingChrome = ({
  helmetTitle,
  description,
  kicker,
  title,
  subtitle,
  children,
}) => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{helmetTitle}</title>
        {description ? <meta name="description" content={description} /> : null}
      </Helmet>

      <div className="marketing-shell">
        <header className="marketing-header sticky top-0 z-50">
          <div className="max-w-3xl mx-auto px-4 h-16 flex items-center justify-between">
            <button
              type="button"
              onClick={() => navigate('/')}
              className="flex items-center gap-3 text-white hover:text-cyan-200 transition-colors"
            >
              <div className="brand-mark w-10 h-10">
                <Icon name="Droplet" size={22} color="#FFFFFF" />
              </div>
              <span className="text-xl font-semibold">{APP_NAME}</span>
            </button>
            <Button variant="default" size="sm" iconName="Calendar" onClick={() => navigate('/service-booking-wizard')}>
              Réserver
            </Button>
          </div>
        </header>

        <main className="py-12 px-4">
          <div className="max-w-3xl mx-auto">
            {kicker ? <p className="marketing-kicker mb-4">{kicker}</p> : null}
            <h1 className="marketing-title text-3xl lg:text-5xl font-heading font-bold mb-3">{title}</h1>
            {subtitle ? <p className="marketing-muted text-lg mb-10 max-w-2xl">{subtitle}</p> : null}
            {children}
          </div>
        </main>

        <footer className="marketing-footer py-8 text-center text-sm marketing-muted px-4">
          <p className="mb-3">© {new Date().getFullYear()} {APP_NAME}. Tous droits réservés.</p>
          <div className="flex flex-wrap justify-center gap-4">
            <a href="/faq" className="marketing-link">FAQ</a>
            <a href="/cgv" className="marketing-link">CGV</a>
            <a href="/privacy-policy" className="marketing-link">Politique de Confidentialité</a>
          </div>
        </footer>
      </div>
    </>
  );
};

export default PublicMarketingChrome;
